export const visit = (vm, at) => {
vm(require("pricing-pages-ui/lang/ja.lyaml"));
vm(require("foundations-components/lang/ja.lyaml"));
vm(require("feature-monetization/lang/ja.lyaml"));
vm(require("usage-based-billing-components-lib/lang/CreditEstimator/ja.lyaml"));
vm(require("usage-based-billing-components-lib/lang/ja.lyaml"));
vm(require("pricing-pages-ui-public-app/lang/header/ja.lyaml"));
vm(require("pricing-pages-ui-public-app/lang/marketing-hub/ja.lyaml"));
vm(require("pricing-pages-ui-public-app/lang/merch-card/ja.lyaml"));
vm(require("pricing-pages-ui-public-app/lang/merch-card-copy/ja.lyaml"));
vm(require("pricing-pages-ui-public-app/lang/merch-card-price/ja.lyaml"));
vm(require("pricing-pages-ui-public-app/lang/merch-card-term/ja.lyaml"));
at({ "ja": { "ui": { "UILoadingSpinner": { "busyText": "\u8AAD\u307F\u8FBC\u307F\u4E2D", "completedText": "\u8AAD\u307F\u8FBC\u307F\u307E\u3057\u305F" } }, "publicPricingPage": { "windowTitles": { "default": "\u4FA1\u683C\u8A2D\u5B9A\uFF5CHubSpot" } } } });
};